import { create } from 'apisauce'
import { errorToast } from '@/mixins/toast'
import router from '@/router'
import store from "@/store"
import { storageGet } from '@/services/storage'

const api = create({
	baseURL: process.env.VUE_APP_BASE_API,
	withCredentials: true
})

api.addResponseTransform(response => {
	const user = storageGet('@stup:user')

	if (user) {
		if ([403, 401].includes(response.status)) {
			store.dispatch('user/deleteUserData')
			router.push('/')
			errorToast('Você não tem permissão para acessar este recurso')
		}
	}

	if (!response.ok) {
		throw response
	}
})

export default api
